import type { IconSvgObject } from './types';

const PineTreeIcon: IconSvgObject = [
  ["path", { d: "M9 18H5L8.70588 13H6L9.52941 8.5H7L12 2L17 8.5H14.4706L18 13H15.2941L19 18H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 14V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PineTreeIcon;
